module.exports = __webpack_public_path__ + "static/media/checkicon.1cfd178d.png";